export default __webpack_public_path__ + "static/media/accept-point.ae9c2b3b.svg";